interface Props {
  paragraphs: string[]
  synonyms?: string[]
}

export function ToolLongForm({ paragraphs, synonyms }: Props) {
  if (paragraphs.length === 0) return null
  return (
    <div className="mt-10 space-y-4 text-sm text-muted-foreground">
      {paragraphs.map((p, i) => (
        <p key={i}>{p}</p>
      ))}
      {synonyms && synonyms.length > 0 && (
        <p className="text-xs text-muted-foreground/60">{synonyms.join(' · ')}</p>
      )}
    </div>
  )
}
